
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Splash from "../pages/splash/page";
import Login from "../pages/auth/login/page";
import Register from "../pages/auth/register/page";
import Dashboard from "../pages/dashboard/page";
import Expenses from "../pages/expenses/page";
import AddIncome from "../pages/add-income/page";
import AddExpense from "../pages/add-expense/page";
import FinancialAlert from "../pages/financial-alert/page";
import Reports from "../pages/reports/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Splash />,
  },
  {
    path: "/auth/login",
    element: <Login />,
  },
  {
    path: "/auth/register",
    element: <Register />,
  },
  {
    path: "/dashboard",
    element: <Dashboard />,
  },
  {
    path: "/expenses",
    element: <Expenses />,
  },
  {
    path: "/add-income",
    element: <AddIncome />,
  },
  {
    path: "/add-expense",
    element: <AddExpense />,
  },
  {
    path: "/financial-alert",
    element: <FinancialAlert />,
  },
  {
    path: "/reports",
    element: <Reports />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
